import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdateCustomerForm from "../../forms/CreateOrUpdateCustomerForm";

const UpdateCustomerModal = ({ open, onClose, customer, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${customer?.name}`}
    width="sm"
    loading={loading}
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdateCustomerForm
      isEditing={true}
      customer={customer}
      loading={loading}
    />
  </AppModal>
);
export default UpdateCustomerModal;
